module.exports = __webpack_public_path__ + "assets/img/hour_glass_w.04a5ada7.svg";